import {
  ADD_NEW_TENANT,
  DELETE_TENANT,
  DELETE_TENANT_DISMISS,
  DELETE_TENANT_PREVIEW,
  EDIT_TENANT,
  EDIT_TENANT_INIT,
  EDIT_TENANT_DISMISS,
  EDIT_TENANT_PREVIEW,
  SET_TENANT_DATA,
  PORTAL_TENANT_FETCHING_COMPLETE,
  PORTAL_TENANT_FETCHING_INIT,
  PORTAL_TENANT_FETCHING_DISMISS,
  ADD_NEW_TENANT_DISMISS,
  ADD_NEW_TENANT_PREVIEW,
  ADD_NEW_TENANT_INIT,
  CHANGE_PORTAL_PAGE,
  LOAD_COUNTRY_LIST,
  LOAD_DISTRIBUTOR_LIST,
  LOAD_LANGUAGE_LIST,
  LOAD_PARENT_COMPANY_LIST,
  LOAD_STATUS_LIST,
  LOAD_INVITE_PARTNER_OPTIONS,
  NORMAL_TENANT_FETCHING_INIT,
  NORMAL_TENANT_FETCHING_DISMISS,
  NORMAL_TENANT_FETCHING_COMPLETE,
  CHANGE_NORMAL_PAGE,
  SEARCH_PORTAL_TENANT,
  SEARCH_NORMAL_TENANT,
  ADD_NEW_TENANT_ERROR,
  EDIT_TENANT_ERROR,
} from "./types";
const initialState = {
  tenant_list: [], //holds tenant list array
  tenantlist_fetching: false, //indicaction for fetch in progress
  portal_tenantlist_refetch: false, //indication to refetch current tenant list array
  portal_tenantlist_refetch_force: false, //indication to force refetch tenant list array from beginning
  normal_tenantlist_refetch: false, //indication to refetch current tenant list array
  normal_tenantlist_refetch_force: false, //indication to force refetch tenant list array from beginning
  edit_tenant: null, //holds initial data of tenant being edited
  delete_tenant: null, //holds initial data of tenant opted to be deleted
  disable_tenant: null, //holds initial data of tenant opted to be disabled,
  //PORTAL TENANT VARIABLES
  portal_page: 1, //page number on tenant listing
  perpage_portal_records: 20, //perpage limit on portal tenant listing
  portal_list_total_count: 0, //total records in portal_list
  portal_list: [],
  portal_search: "",
  //NORMAL TENANT VARIABLES
  normal_page: 1, //page number on tenant listing
  perpage_normal_records: 20, //perpage limit on portal tenant listing
  normal_list_total_count: 0, //total records in portal_list
  normal_list: [],
  normal_search: "",
  //property fileds
  countries: [], //countries list
  distributors: [], //distributors list
  languages: [], //languages list
  parent_companies: [], //parent_companies list
  status: [],
  invite_partner_options: [], // invite parner dropdown options
  //Add tenant variables
  nT_sub_module_ids: [],
  nT_org_type_id: 0,
  nT_role_id: 0,
  nT_country_operation_id: 0,

  nT_country_id: 0,
  nT_parent_org_id: 0,
  nT_language_id: 0,
  nT_org_name: "",
  nT_email: "",
  nT_phone_number: "",
  nT_parent_company: "",
  nT_parent_cmpny_status: true,
  nT_contact_person_name: "",
  nT_distributor_id: 0,
  nT_distributor_status: true,
  nT_service_charge: 1000,
  nT_comments: "",
  nT_status: "",
  nT_distributor: "",
  //edit tenant variables
  eT_country_id: 0,
  eT_parent_org_id: 0,
  eT_language_id: 0,
  eT_org_name: "",
  eT_email: "",
  eT_phone_number: "",
  eT_parent_company: "",
  eT_parent_cmpny_status: true,
  eT_contact_person_name: "",
  eT_distributor_id: 0,
  eT_distributor_status: true,
  eT_service_charge: 1000,
  eT_comments: "",
  eT_status: "",
  eT_distributor: "",
  // submit btns
  add_tenant_btn_disable: false,
  edit_tenant_btn_disable: false,
  del_tenant_btn_disable: false,
  // Opts
  partner_opts: [],
  //tokenHistory
  token_history_list: [],
  is_token_history_loading: false,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_TENANT_DATA:
      return { ...state, ...action.payload };
    case PORTAL_TENANT_FETCHING_INIT: {
      return {
        ...state,
        tenantlist_fetching: true,
        portal_tenantlist_refetch: false,
        portal_tenantlist_refetch_force: false,
      };
    }
    case PORTAL_TENANT_FETCHING_COMPLETE: {
      return {
        ...state,
        tenantlist_fetching: false,
        ...action.payload,
      };
    }
    case PORTAL_TENANT_FETCHING_DISMISS: {
      return { ...state, tenantlist_fetching: false };
    }
    case CHANGE_PORTAL_PAGE: {
      return {
        ...state,
        portal_tenantlist_refetch: true,
        portal_page: action.payload,
      };
    }
    case NORMAL_TENANT_FETCHING_INIT: {
      return {
        ...state,
        tenantlist_fetching: true,
        normal_tenantlist_refetch: false,
        normal_tenantlist_refetch_force: false,
      };
    }
    case NORMAL_TENANT_FETCHING_DISMISS: {
      return { ...state, tenantlist_fetching: false };
    }
    case NORMAL_TENANT_FETCHING_COMPLETE: {
      return { ...state, tenantlist_fetching: false, ...action.payload };
    }
    case CHANGE_NORMAL_PAGE: {
      return {
        ...state,
        normal_tenantlist_refetch: true,
        normal_page: action.payload,
      };
    }
    case LOAD_COUNTRY_LIST: {
      return { ...state, countries: action.payload };
    }
    case LOAD_DISTRIBUTOR_LIST: {
      return { ...state, distributors: action.payload };
    }
    case LOAD_LANGUAGE_LIST: {
      return { ...state, languages: action.payload };
    }
    case LOAD_PARENT_COMPANY_LIST: {
      return { ...state, parent_companies: action.payload };
    }
    case LOAD_STATUS_LIST: {
      return { ...state, status: action.payload };
    }
    case LOAD_INVITE_PARTNER_OPTIONS: {
      return { ...state, invite_partner_options: action.payload };
    }
    case ADD_NEW_TENANT_INIT: {
      return { ...state, add_tenant_btn_disable: true };
    }
    case ADD_NEW_TENANT: {
      return {
        ...state,
        add_tenant_btn_disable: false,
        portal_tenantlist_refetch: true,
        normal_tenantlist_refetch: true,
        search: "",
        normal_page: 1,
        portal_page: 1,
      };
    }
    case ADD_NEW_TENANT_PREVIEW: {
      return {
        ...state,
        new_tenant_popup: true,

        nT_sub_module_ids: [1],
        nT_org_type_id: 0,
        nT_role_id: 1,
        nT_country_operation_id: 0,

        nT_country_id: 0,
        nT_parent_org_id: 0,
        nT_language_id: 0,
        nT_org_name: "",
        nT_email: "",
        nT_phone_number: "",
        nT_parent_company: "",
        nT_parent_cmpny_status: true,
        nT_contact_person_name: "",
        nT_distributor_id: 0,
        nT_distributor_status: true,
        nT_service_charge: 1000,
        nT_comments: "",
        nT_status: "",
        nT_distributor: "",
      };
    }
    case ADD_NEW_TENANT_DISMISS: {
      return {
        ...state,
        new_tenant_popup: false,
        ...action.payload,
        add_tenant_btn_disable: false,
      };
    }
    case ADD_NEW_TENANT_ERROR: {
      return { ...state, add_tenant_btn_disable: false };
    }
    case EDIT_TENANT_PREVIEW: {
      return { ...state, edit_tenant_btn_disable: false, ...action.payload };
    }
    case EDIT_TENANT_INIT: {
      return { ...state, edit_tenant_btn_disable: true, ...action.payload };
    }
    case EDIT_TENANT: {
      return {
        ...state,
        portal_tenantlist_refetch: true,
        normal_tenantlist_refetch: true,
        search: "",
        normal_page: 1,
        portal_page: 1,
        edit_tenant_btn_disable: false,
      };
    }
    case EDIT_TENANT_DISMISS: {
      return { ...state, edit_tenant: null, edit_tenant_btn_disable: true };
    }
    case EDIT_TENANT_ERROR: {
      return { ...state, edit_tenant_btn_disable: true };
    }
    case DELETE_TENANT_PREVIEW: {
      return {
        ...state,
        del_btn_disable: false,
        delete_tenant: action.payload,
      };
    }
    case DELETE_TENANT: {
      return {
        ...state,
        delete_tenant: null,
        portal_tenantlist_refetch_force: true,
        normal_tenantlist_refetch_force: true,
        del_btn_disable: false,
      };
    }
    case DELETE_TENANT_DISMISS: {
      return { ...state, delete_tenant: null };
    }
    case SEARCH_PORTAL_TENANT: {
      return {
        ...state,
        portal_tenantlist_refetch_force: true,
        portal_search: action.payload,
      };
    }
    case SEARCH_NORMAL_TENANT: {
      return {
        ...state,
        normal_tenantlist_refetch_force: true,
        normal_search: action.payload,
      };
    }
    default:
      return state;
  }
};
